import { clearVoicemailCache } from './voicemailStorage';
import { clearCallHistoryCache } from './callHistoryStorage';
import { queueService } from '../../interpreter-queue/InterpreterQueueService';
import { resetInterpreterQueueMiddleware } from '../../interpreter-queue/middleware';
import { initializeNativeSignOut, startNativeSignOut } from '../../vrs-auth/nativeSignOut';
import { beginPrivateJobDraftCleanup } from './clearPrivateJobDrafts';
import { beginSchedulingCacheCleanup } from './components/vri/vriSchedulingCache';
import { beginUsageCacheCleanup } from './components/vri/vriUsageCache';
import { beginOperatorInstructionsCleanup } from './operatorInstructions';
import { mobileLog } from './logging';
export { MOBILE_SIGN_OUT_STORAGE_KEYS } from '../../vrs-auth/nativeSignOut';
/** One failed queue send must not prevent disconnection, draft fencing, or cleanup. */
function retireMobileSession() {
    const actions = [
        beginPrivateJobDraftCleanup, beginOperatorInstructionsCleanup,
        beginSchedulingCacheCleanup, beginUsageCacheCleanup,
        () => queueService.endActiveCall(), () => queueService.disconnect(),
        resetInterpreterQueueMiddleware, clearCallHistoryCache, clearVoicemailCache
    ];
    actions.forEach(action => {
        try {
            void Promise.resolve(action()).catch(() => mobileLog('warn', 'mobile_sign_out_retirement_failed', {}));
        }
        catch {
            mobileLog('warn', 'mobile_sign_out_retirement_failed', {});
        }
    });
}
export function initializeMobileSignOut() {
    return initializeNativeSignOut(retireMobileSession);
}
export function signOutMobileUser(endMedia) {
    return startNativeSignOut(() => {
        retireMobileSession();
        try {
            void Promise.resolve(endMedia?.()).catch(() => mobileLog('warn', 'mobile_sign_out_media_cleanup_failed', {}));
        }
        catch {
            mobileLog('warn', 'mobile_sign_out_media_cleanup_failed', {});
        }
    });
}
